<template lang='pug' src='./header.pug'> </template>

<script>
  import Icon from 'components/icon/icon'

  export default {
    name: 'themeoptions',
    computed: {
      props () {
        return this.$store.state.app['themeoptions']
      }
    },
    components: {
      Icon
    },
    methods: {
      scrollSectionAboutUs () {
        this.$router.push('/')
        setTimeout(() => { this.$scrollTo('#about-us') }, 200)
      },
      scrollSectionOurTeam () {
        this.$router.push('/')
        setTimeout(() => { this.$scrollTo('#our-team') }, 200)
      },
      scrollSectionCovid () {
        this.$router.push('/')
        setTimeout(() => { this.$scrollTo('#covid-info') }, 200)
      },
      scrollSectionTechnology () {
        this.$router.push('/')
        setTimeout(() => { this.$scrollTo('#technology') }, 200)
      },
      scrollSectionMedia () {
        this.$router.push('/')
        setTimeout(() => { this.$scrollTo('#media') }, 200)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// header.vue?828db824